import CardBox from "atomicComponents/CardBox";
import LayoutContent from "atomicComponents/LayoutContent";
import AccessSettings from "components/Settings/AccessSettings";
import Layout from "containers/Layout";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Tabs from "../atomicComponents/Tabs";
import { useAuth } from "shared/providers/AuthProvider";

const OrganizationSettings = () => {
  const { t } = useTranslation("common");
  const auth = useAuth();
  const details = auth[1];

  const tabs = useMemo(() => {
    return [
      {
        id: "access_settings",
        title: t("settings.access_settings"),
        content: <AccessSettings details={details} />,
      },
    ];
  }, [details, t]);

  return (
    <Layout>
      <LayoutContent title={t("account.profile.settings")}>
        <CardBox>
          <Tabs tabs={tabs} defaultActiveTab="access_settings" />
        </CardBox>
      </LayoutContent>
    </Layout>
  );
};

export default OrganizationSettings;
